import axios, {AxiosResponse} from 'axios'
import {ID, Response} from '../../../../../_metronic/helpers'
import {Model, QueryResponse} from './_models'
import {SendAcceptanceLetterToEbysRequest} from '../components/pdf/models/SendAcceptanceLetterToEbysRequest'

const API_URL = process.env.REACT_APP_API_URL
const PROP_URL = `${API_URL}/ApplicationUser`
const CUSTOM_PROP_URL = `${API_URL}/Custom`
const CUSTOM_TRYOS_MODAL = `${API_URL}/Custom/GetTrYosInfo`
const CUSTOM_RESET_SURVEYS = `${API_URL}/Custom/ResetSurvey`
const CUSTOMGETUSERS = `${API_URL}/Custom/GetApplicationUserList`

function capitalizeFirstLetter(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}
const getApplicationUser = (
  query: string,
  select?: string,
  modelstoinclude?: string
): Promise<QueryResponse> => {
  //console.log(query)
  const qis = query.split('&')
  let newq: Array<string> = []
  qis.map((q) => {
    if (q.startsWith('filter') && q.slice(-1) != '=') {
      if (q.includes('_id')) {
        const aq = capitalizeFirstLetter(
          q.replace('_id', 'Id').replace('filter_', '').replace('=', '*')
        )
        //console.log(aq)
        newq.push(aq)
      } else if (q.includes('strt') && !q.includes(' ')) {
        const aq =
          '(Date)' +
          capitalizeFirstLetter(
            q.replace('strt', '').replace('filter_', '').replaceAll('-', '.').replace('=', '>')
          )
        //console.log(aq)
        newq.push(aq)
      } else if (q.includes('ndnd') && !q.includes(' ')) {
        const aq =
          '(Date)' +
          capitalizeFirstLetter(
            q.replace('ndnd', '').replace('filter_', '').replaceAll('-', '.').replace('=', '<')
          )
        //console.log(aq)
        newq.push(aq)
      } else if (q.includes('String')) {
        const aq = capitalizeFirstLetter(
          q.replace('String', '').replace('filter_', '').replace('=', '_')
        )
        //console.log(aq)
        newq.push(aq)
      } else if (q.includes('stNMB')) {
        const aq = capitalizeFirstLetter(
          q.replace('stNMB', '').replace('filter_', '').replace('=', '>')
        )
        //console.log(aq)
        newq.push(aq)
      } else if (q.includes('enNMB')) {
        const aq = capitalizeFirstLetter(
          q.replace('enNMB', '').replace('filter_', '').replace('=', '<')
        )
        //console.log(aq)
        newq.push(aq)
      } else if (q.includes('BL')) {
        const aq = capitalizeFirstLetter(
          q.replace('BL', '').replace('filter_', '').replace('=', '*')
        )
        //console.log(aq)
        newq.push(aq)
      }
    }
  })
  const newqstring = newq.filter((f) => f).join('|')

  let mti = ''
  if (modelstoinclude != undefined && modelstoinclude != '') {
    mti = '&modelstoinclude=' + modelstoinclude
  }
  let sti = ''
  if (select != undefined && select != '') {
    sti = '&select=' + select
  }

  return axios
    .get(
      `${PROP_URL}/getAll/Id!5451,6925,9355,5584,-1,16,19${
        newqstring ? '|' + newqstring : ''
      }?${query}${mti}${sti}`
    )
    .then((d: AxiosResponse<QueryResponse>) => d.data)
}

const getApplicationUser2 = (
  query: string,
  select?: string,
  modelstoinclude?: string
): Promise<QueryResponse> => {
  //console.log(query)
  const qis = query.split('&')
  let newq: Array<string> = []
  qis.map((q) => {
    if (q.startsWith('filter') && q.slice(-1) != '=') {
      if (q.includes('_id')) {
        const aq = capitalizeFirstLetter(
          q.replace('_id', 'Id').replace('filter_', '').replace('=', '*')
        )
        //console.log(aq)
        newq.push(aq)
      } else if (q.includes('strt') && !q.includes(' ')) {
        const aq =
          '(Date)' +
          capitalizeFirstLetter(
            q.replace('strt', '').replace('filter_', '').replaceAll('-', '.').replace('=', '>')
          )
        //console.log(aq)
        newq.push(aq)
      } else if (q.includes('ndnd') && !q.includes(' ')) {
        const aq =
          '(Date)' +
          capitalizeFirstLetter(
            q.replace('ndnd', '').replace('filter_', '').replaceAll('-', '.').replace('=', '<')
          )
        //console.log(aq)
        newq.push(aq)
      } else if (q.includes('String')) {
        const aq = capitalizeFirstLetter(
          q.replace('String', '').replace('filter_', '').replace('=', '_')
        )
        //console.log(aq)
        newq.push(aq)
      } else if (q.includes('stNMB')) {
        const aq = capitalizeFirstLetter(
          q.replace('stNMB', '').replace('filter_', '').replace('=', '>')
        )
        //console.log(aq)
        newq.push(aq)
      } else if (q.includes('enNMB')) {
        const aq = capitalizeFirstLetter(
          q.replace('enNMB', '').replace('filter_', '').replace('=', '<')
        )
        //console.log(aq)
        newq.push(aq)
      } else if (q.includes('BL')) {
        const aq = capitalizeFirstLetter(
          q.replace('BL', '').replace('filter_', '').replace('=', '*')
        )
        //console.log(aq)
        newq.push(aq)
      }
    }
  })
  const newqstring = newq.filter((f) => f).join('|')

  let mti = ''
  if (modelstoinclude != undefined && modelstoinclude != '') {
    mti = '&modelstoinclude=' + modelstoinclude
  }
  let sti = ''
  if (select != undefined && select != '') {
    sti = '&select=' + select
  }

  return axios
    .get(`${PROP_URL}/getAll/Id*5451,6925,9355,5584,-1,16,19,11322?${query}${mti}${sti}`)
    .then((d: AxiosResponse<QueryResponse>) => d.data)
}

const listApplicationUser = async (select?: string, modelstoinclude?: string): Promise<any> => {
  let mti = ''
  if (modelstoinclude != undefined) {
    mti = '&modelstoinclude=' + modelstoinclude
  }
  return await axios
    .get(`${PROP_URL}/getAll?page=1&items_per_page=99999${mti}&select=${select}`)
    .then((res: AxiosResponse) => {
      return res.data
    })
}

const getApplicationUserById = (id: ID): Promise<Model | undefined> => {
  return axios
    .get(`${PROP_URL}/${id}`)
    .then((response: AxiosResponse<Response<Model>>) => response.data)
    .then((response: Response<Model>) => response as any)
}

const getApplicationUserTryosDataById = (id: any): Promise<Model | undefined> => {
  return axios
    .get(`${CUSTOM_TRYOS_MODAL}?userid=${id}`)
    .then((response: AxiosResponse<Response<any>>) => response.data)
    .then((response: Response<any>) => response as any)
}

const resetSurveys = (id: any, reason: any): Promise<Model | undefined> => {
  return axios
    .post(`${CUSTOM_RESET_SURVEYS}?userid=${id}&rejectionReason=${reason}`)
    .then((response: AxiosResponse<Response<any>>) => response.data)
    .then((response: Response<any>) => response as any)
}

const createApplicationUser = (prop: Model): Promise<Model | undefined> => {
  return axios
    .put(PROP_URL, prop)
    .then((response: AxiosResponse<Response<Model>>) => response.data)
    .then((response: Response<Model>) => response.data)
}

const confirmApplication = (prop: number): Promise<Model | undefined> => {
  return axios
    .post(`${CUSTOM_PROP_URL}/confirm_application?id=${prop}`)
    .then((response: AxiosResponse<Response<Model>>) => response.data)
    .then((response: Response<Model>) => response.data)
}

const rejectApplication = (
  prop: number,
  reason: string,
  İsRejectFile: Boolean
): Promise<Model | undefined> => {
  return axios
    .post(
      `${CUSTOM_PROP_URL}/reject_application?id=${prop}&rejectionReason=${reason}&isRejectFileRequired=${İsRejectFile}`
    )
    .then((response: AxiosResponse<Response<Model>>) => response.data)
    .then((response: Response<Model>) => response.data)
}

const resetApplication = (prop: number, reason: string): Promise<Model | undefined> => {
  return axios
    .post(`${CUSTOM_PROP_URL}/reset_application?id=${prop}&rejectionReason=${reason}`)
    .then((response: AxiosResponse<Response<Model>>) => response.data)
    .then((response: Response<Model>) => response.data)
}

const updateApplicationUser = (prop: Model): Promise<Model | undefined> => {
  return axios
    .post(`${PROP_URL}/${prop.id}`, prop)
    .then((response: AxiosResponse<Response<Model>>) => response.data)
    .then((response: Response<Model>) => response.data)
}

const deleteApplicationUser = (propId: ID): Promise<void> => {
  return axios.delete(`${PROP_URL}/${propId}`).then(() => {})
}

const deleteSelectedApplicationUser = (propIds: Array<ID>): Promise<void> => {
  const requests = propIds.map((id) => axios.delete(`${PROP_URL}/${id}`))
  return axios.all(requests).then(() => {})
}

const getCustomApplicationUser = async (filter?: string): Promise<any> => {
  return await axios.get(`${CUSTOMGETUSERS}?${filter}`).then((res: AxiosResponse) => {
    return res.data
  })
}

const listCustomApplicationUser = async (): Promise<any> => {
  return await axios.get(`${CUSTOM_PROP_URL}/ListApplicationUser`).then((res: AxiosResponse) => {
    return res.data
  })
}

// const checkKabulMektubu = (prop: number): Promise<Model | undefined> => {
//   return axios
//     .post(`${CUSTOM_PROP_URL}/CheckKabulMektubu?userId=${prop}`)
//     .then((response: AxiosResponse<Response<Model>>) => response.data)
//     .then((response: Response<Model>) => response.data)
// }

const checkKabulMektubu = (prop: number) => {
  return axios.post(`${CUSTOM_PROP_URL}/CheckKabulMektubu?userId=${prop}`)
}

const getAcceptanceLetterInfos = async (studentIds: number[]) => {
  const response = await axios.post(`${CUSTOM_PROP_URL}/GetAcceptanceLetterInfos`, studentIds)

  return response.data
}

const sendAcceptanceLetterToEbys = async (request: SendAcceptanceLetterToEbysRequest) => {
  const response = await axios.post(`${CUSTOM_PROP_URL}/SendAcceptanceLetterToEbys`, request)

  return response.data
}

const downloadAcceptanceLetter = async (userId: number): Promise<Blob> => {
  const response = await axios.get(`${CUSTOM_PROP_URL}/DownloadAcceptanceLetter`, {
    params: {userId},
    responseType: 'blob', // PDF binary verisi olarak almak için şarttır.
  })
  return response.data
}

const downloadAcceptanceLetterAsStudent = async () => {
  const response = await axios.get(`${CUSTOM_PROP_URL}/DownloadAcceptanceLetterAsStudent`, {
    responseType: 'blob',
  })
  return response.data
}

const getIsAcceptanceLetterButtonVisible = () =>
  axios
    .get<boolean>(`${CUSTOM_PROP_URL}/GetIsAcceptanceLetterButtonVisible`)
    .then((res) => res.data)
export {
  getApplicationUser,
  resetSurveys,
  getApplicationUserTryosDataById,
  deleteApplicationUser,
  deleteSelectedApplicationUser,
  getApplicationUserById,
  createApplicationUser,
  updateApplicationUser,
  listApplicationUser,
  confirmApplication,
  rejectApplication,
  resetApplication,
  getApplicationUser2,
  getCustomApplicationUser,
  listCustomApplicationUser,
  checkKabulMektubu,
  getAcceptanceLetterInfos,
  sendAcceptanceLetterToEbys,
  downloadAcceptanceLetter,
  downloadAcceptanceLetterAsStudent,
  getIsAcceptanceLetterButtonVisible,
}
